import script from "./LiveSession.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSession.vue?vue&type=script&setup=true&lang=js"

import "./LiveSession.vue?vue&type=style&index=0&id=4a7b2117&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7b2117"]])

export default __exports__